import * as yup from 'yup';
import { B2BCreditCardsFilterType } from '../../../api/b2b/payments';
import { NICKNAME_INVALID, CARD_LAST_4_INVALID, CITI_SEARCH_INVALID, EXPIRY_INVALID, NICKNAME_TOO_LONG, } from '../../../constants/field-error-messages';
import { NICKNAME_REGEX, CARD_LAST_4_DIGITS_REGEX, EXPIRY_REGEX, } from '../../../constants/regex';
export const searchCreditCardValidationSchema = yup.object().shape({
    filterValue: yup
        .string()
        .when('filterType', {
        is: B2BCreditCardsFilterType.nickName.valueOf(),
        then: (schema) => schema
            .matches(NICKNAME_REGEX, { message: NICKNAME_INVALID.message })
            .max(50, NICKNAME_TOO_LONG.message),
    })
        .when('filterType', {
        is: B2BCreditCardsFilterType.cardLast4Digits.valueOf(),
        then: (schema) => schema
            .matches(CARD_LAST_4_DIGITS_REGEX, {
            message: CARD_LAST_4_INVALID.message,
        })
            .min(4, CARD_LAST_4_INVALID.message)
            .max(4, CARD_LAST_4_INVALID.message),
    })
        .when('filterType', {
        is: B2BCreditCardsFilterType.citiID.valueOf(),
        then: (schema) => schema
            .matches(CARD_LAST_4_DIGITS_REGEX, {
            message: CITI_SEARCH_INVALID.message,
        })
            .min(4, CITI_SEARCH_INVALID.message)
            .max(4, CITI_SEARCH_INVALID.message),
    })
        .when('filterType', {
        is: B2BCreditCardsFilterType.expDate.valueOf(),
        then: (schema) => schema.matches(EXPIRY_REGEX, {
            message: EXPIRY_INVALID.message,
        }),
    }),
});
